var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base_container"},[_c('span',[_vm._v("当前用户信息有误或权限过低，请联系管理员")])])
}]

export { render, staticRenderFns }